import React, { Component } from 'react';
import ReactGA from 'react-ga';

export default class Default extends Component {
  componentWillMount() {
    if (typeof window !== "undefined" && window.location.hostname !== "localhost") {
      ReactGA.initialize(this.props.ga);
    }
  }

  componentDidMount() {
    require('expose?$!expose?jQuery!jquery');
    require('foundation-sites');
    $(document).foundation();
  }

  render() {

    return (
      <html>
        <head>
          <meta charSet='utf-8' />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          { this.props.env === 'production' && <link href="/styles.css" rel="stylesheet" /> }
          {/* <link rel="shortcut icon" href="/favicon.ico" /> */}
          <link rel="icon" sizes="132x132" href="images/browserlogo.png"/>
          <script src="https://use.fontawesome.com/3df59d8a17.js"></script>
          <title>Natural elements</title>
        </head>
        <body ref={(ref) => this.body = ref}>
          <div>
            {this.props.children}
          </div>
          <script src='/bundle.js'></script>
        </body>
      </html>
    );
  }
};



// WEBPACK FOOTER //
// ./templates/views/default.jsx